/** Estado de um limite de plano para fins de apresentação. */
export type LimitStatus = 'none' | 'soft' | 'hard';

/**
 * Decide o estado do limite. `limite === null` significa ilimitado → 'none'.
 * Thresholds: >=100% → 'hard', >=80% → 'soft', abaixo → 'none'.
 */
export function getLimitStatus(usoAtual: number, limite: number | null): LimitStatus {
  if (limite === null) return 'none';
  const ratio = usoAtual / limite;
  if (ratio >= 1.0) return 'hard';
  if (ratio >= 0.8) return 'soft';
  return 'none';
}

/**
 * Deteta se um novo ratio cruza um threshold relativamente ao ratio anterior.
 * Usado para disparar analytics no máximo uma vez por travessia.
 */
export function detectThresholdCrossing(
  previousRatio: number | null,
  ratio: number,
): { soft: boolean; hard: boolean } {
  const soft = (previousRatio === null || previousRatio < 0.8) && ratio >= 0.8 && ratio < 1.0;
  const hard = (previousRatio === null || previousRatio < 1.0) && ratio >= 1.0;
  return { soft, hard };
}
